import type { AreaCatalog } from '../area';
import type { ceremonies as en } from '../en/ceremonies';

export const ceremonies = {
  // --- The Ceremonies index ---
  'ceremonies.index.title': 'Besprechungen',
  'ceremonies.index.sub': 'gebündelte Entscheidungen',
  'ceremonies.index.openOf': '{open} von {count} offen',
  'ceremonies.index.empty':
    'Noch keine Besprechungen. Berufe eine ein, um Entscheidungen zu bündeln (Vorrücken, Anhalten, Abnehmen) und sie gemeinsam durchzugehen.',
  'ceremonies.index.items': { one: '{count} Aufgabe', other: '{count} Aufgaben' },
  'ceremonies.index.itemsPending': {
    one: '{count} Aufgabe · {pending} offen',
    other: '{count} Aufgaben · {pending} offen',
  },
  'ceremonies.status.open': 'offen',
  'ceremonies.status.closed': 'beendet',
  'ceremonies.unreached':
    'Die Aktion hat den Server nicht erreicht. Lade neu und versuche es noch einmal.',
  // --- Convene ---
  'ceremonies.convene.placeholder': 'Besprechung einberufen…',
  'ceremonies.convene.title': 'Titel der Besprechung',
  'ceremonies.convene.submit': 'Einberufen',
  // --- A ceremony's review: the head ---
  'ceremonies.review.convenedBy': 'Einberufen von {name}',
  'ceremonies.review.close': 'Besprechung beenden',
  'ceremonies.review.somethingWrong': 'Etwas ist schiefgegangen.',
  // --- Participants ---
  'ceremonies.participants.title': 'Teilnehmende',
  'ceremonies.participants.empty': 'Noch niemand eingetragen.',
  'ceremonies.role.facilitator': 'Moderierende',
  'ceremonies.role.decider': 'Entscheidende',
  'ceremonies.role.contributor': 'Mitwirkende',
  'ceremonies.role.observer': 'Beobachtende',
  'ceremonies.roleChip.facilitator': 'Moderierende',
  'ceremonies.roleChip.decider': 'Entscheidende',
  'ceremonies.roleChip.contributor': 'Mitwirkende',
  'ceremonies.roleChip.observer': 'Beobachtende',
  'ceremonies.participants.roleFor': 'Rolle von {name}',
  'ceremonies.participants.remove': 'Entfernen',
  'ceremonies.participants.suggested': 'Vorgeschlagene Entscheidende:',
  'ceremonies.participants.add': 'Teilnehmende hinzufügen',
  'ceremonies.participants.addPlaceholder': 'Person oder Gruppe hinzufügen…',
  'ceremonies.participants.role': 'Rolle',
  'ceremonies.participants.addSubmit': 'Hinzufügen',
  // --- Add a decision ---
  'ceremonies.choice.accept': 'Abnehmen',
  'ceremonies.choice.dispute': 'Abnahme verweigern',
  'ceremonies.choice.resolve': 'Klären (Bewertung wieder öffnen)',
  'ceremonies.choice.advance': 'Zu {stage} vorrücken · {flow}',
  'ceremonies.choice.hold': 'Anhalten · {flow}',
  'ceremonies.decision.search': 'Entscheidung hinzufügen: Aufgabe suchen…',
  'ceremonies.decision.searchLabel': 'Aufgabe für die Entscheidung suchen',
  'ceremonies.decision.name': 'Name der Entscheidung (optional)…',
  'ceremonies.decision.nameLabel': 'Name der Entscheidung',
  'ceremonies.decision.choiceLabel': 'Vorzumerkende Entscheidung',
  'ceremonies.decision.choice': 'Entscheidung wählen…',
  'ceremonies.decision.removeDecider': 'Entscheidende entfernen',
  'ceremonies.decision.addDecider': 'Entscheidende hinzufügen',
  'ceremonies.decision.addDeciderPlaceholder': '+ Entscheidende',
  'ceremonies.decision.reason': 'Grund (optional)…',
  'ceremonies.decision.reasonLabel': 'Grund',
  'ceremonies.decision.add': 'Hinzufügen',
  'ceremonies.decision.cancel': 'Abbrechen',
  // --- The agenda ---
  'ceremonies.agenda.empty':
    'Noch keine Entscheidungen auf der Tagesordnung. Suche oben eine Aufgabe, um eine hinzuzufügen, oder merke ein Vorrücken oder Anhalten in der Ablaufleiste einer Aufgabe vor.',
  'ceremonies.outcome.advance': 'Vorrücken',
  'ceremonies.outcome.hold': 'Anhalten',
  'ceremonies.outcome.accept': 'Abnehmen',
  'ceremonies.outcome.dispute': 'Abnahme verweigern',
  'ceremonies.outcome.resolve': 'Klären',
  'ceremonies.agenda.restricted': 'verborgene Aufgabe',
  'ceremonies.agenda.take': 'Umsetzen',
  'ceremonies.agenda.decline': 'Ablehnen',
  'ceremonies.itemStatus.pending': 'offen',
  'ceremonies.itemStatus.applied': 'umgesetzt',
  'ceremonies.itemStatus.declined': 'abgelehnt',
} as const satisfies AreaCatalog<typeof en>;
